import { h, cloneElement } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {

	render(props) {
		const base = super.render(props);
		const navContainer = findInVNode(base, '[role="navigation"]');
		if (navContainer) {
			navContainer.nodeName = 'nav';
		}
		return base;
	}

	renderStandardLinks() {
		const base = super.renderStandardLinks();
		if (!base) return null;

		const tt = findInVNode(base.children, `.${s.tt}`);
		const newChildren = [
			tt,
			<ul>
				{this.standardLinks.map(link => <li key={link.key}>{this.renderLink(link, false)}</li>)}
			</ul>
		];

		return cloneElement(base, base.props, newChildren);
	}

	renderFeaturedLinks() {
		const base = super.renderFeaturedLinks();
		if (!base) return null;

		const newChildren = (
			<ul>
				{this.featuredLinks.map(link => <li key={link.name}>{this.renderLink(link, true)}</li>)}
			</ul>
		);

		return cloneElement(base, base.props, newChildren);
	}
}
